import { HEALTHSTATE } from '.'
import { HealthState } from '../../types/state'
import { COOKIE_PASSCODE, COOKIE_SIGNUP_TRACKER } from '../constants'
import { HEALTH } from '../constants/enums'
import {
    FCSWS_HANDSHAKE_MEMBER,
    FCSWS_LOGIN_VERSION,
} from '../mfcLogic/mfcConstants'
import { registerTimer } from '../state/state.timers'
import { eraseCookie, getCookie } from '../utilities/cookies'
import { sample } from '../utilities/math'
import { customStateWrapper } from './customStateWrapper'
import { pubSubHealth } from './pubSub'

type SetHealthStateOptions = { immediate?: boolean }

const setHealthState = customStateWrapper<HealthState, SetHealthStateOptions>(
    (_, { immediate = false } = {}) => {
        pubSubHealth.emit('state', HEALTHSTATE.health, immediate)
    },
)((updates) => {
    HEALTHSTATE.health = { ...HEALTHSTATE.health, ...updates }
})

export const getHealthState = () => HEALTHSTATE.health

const setHealthStatusState = (status: HEALTH) => {
    setHealthState({
        connecting: status === HEALTH.CONNECTING,
        connected: status === HEALTH.CONNECTED,
        paused: status === HEALTH.PAUSED,
        error: status === HEALTH.ERROR,
        status,
    })
}

const setHealthInterval = () => {
    // Reload the site if they are logged in and the passcode cookie disappears (logged out)
    // or value has changed (logged in different account)
    const state = { previous: getCookie(COOKIE_PASSCODE) }
    registerTimer(
        'health',
        function () {
            if (getCookie(COOKIE_SIGNUP_TRACKER) === 'true') {
                state.previous = getCookie(COOKIE_PASSCODE)
                eraseCookie(COOKIE_SIGNUP_TRACKER)
            }
            if (getCookie(COOKIE_PASSCODE) !== state.previous) {
                location.reload()
            }
        },
        2000,
    )
}

export const healthStateMutators = (event) => {
    const {
        data: { status },
    } = event
    if (status === HEALTH.CONNECTED) {
        setHealthInterval()
    }

    if (status === HEALTH.ERROR) {
        registerTimer('internalError', () => tryFCSConnection(), 30000)
    }

    setHealthStatusState(status)

    const { status: previousStatus } = getHealthState()
    pubSubHealth.emit('HEALTH', {
        previous: previousStatus,
        current: status,
    })
}

function tryFCSConnection() {
    const { websocket_servers: sockets } = window.__MFC_APP_SERVERS__
    const server = sample(Object.keys(sockets))
    const url = 'wss://' + server + '.myfreecams.com/fcsl'
    const instance = new WebSocket(url)

    instance.onopen = () => {
        instance.send(FCSWS_HANDSHAKE_MEMBER + '\n\0')
        instance.send(`1 0 0 ${FCSWS_LOGIN_VERSION} 0 1/guest:guest\n\0`)
    }

    instance.onmessage = () => {
        location.reload()
    }
}
